import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { menuList } from '../../../utils/fakeData/menuList';
import white_logo from "../../../assets/images/white-logo.png";
import black_logo from "../../../assets/images/black-logo.png";
import placeholder from '../../../assets/images/placeholder_image.jpg';

// User profilePic and userName
const UserSection = ({ userData, handleLogout, setMenuActive, style }) => {
  if (userData.status === 'loading') {
    return null;
  }

  return userData.email ? (
    <li className="nav-item align-items-center" style={{ display: 'flex', ...style }}>
      <Link className="text-decoration-none" style={{ border:'none' }} to="/profile">
        <img
          src={userData.profilePicData || placeholder}
          alt="User"
          className="rounded-circle me-2"
          style={{ width: '40px', height: '40px', objectFit: 'cover' }}
        />
        <span className="me-3" style={{ color: "black" }}>
          {(userData.name !== 'User' ? userData.name : userData.email.split('@')[0]) || 'Unauthorized User'}
        </span>
      </Link>
      <Button color="outline-danger" className="btn-logout" onClick={handleLogout}>
        登出
      </Button>
    </li>
  ) : (
    <Link to="/login" style={{ border: 'none', height: '100%', width: '100%' }} 
      onClick={()=>{setMenuActive(false);}}
    >
      <li 
        style={{     
          display: 'flex',
          height: '100%',
          width: '100%',
          justifyContent: 'center'
        }}
      >
        <i className="ri-login-box-line"></i>
        登入
      </li>
    </Link>
  );
};

/* Dropdown Menu when small screen */
const MobileMenu = ({ menuActive, setMenuActive, menuStyle, userData, handleLogout }) => {

  const [dropdownActive, setDropDownActive] = useState(null);
  const logoImage = menuStyle==='white' ? white_logo : black_logo;


  {/* .mobile-responsive-nav: media only and display: block when <992px */}
  return (

    <div className="mobile-responsive-nav"> 
      <div className="container">
        <div className="mobile-responsive-menu">
          
          {/* Black or White Logo */}
          <div className="logo">
            <Link to="/">
              <img src={logoImage} className="main-logo" alt="logo" />
            </Link>
          </div>

          <div 
            className={`bg-white overflow-hidden mobile-responsive-inner shadow 
            ${menuActive ? "mobile-responsive-active" : ""} `}
            style={{ padding:'0', top: '4rem' }}
          >

            <div 
              className="mobile-user-section"
              style={{ 
                display: 'flex', 
                justifyContent:'center',
                padding: '10px 0px 6px 0px',
                backgroundColor: '#f3f3f3'
              }}
            >
              <UserSection
                userData={userData}
                handleLogout={handleLogout}
                setMenuActive={setMenuActive}
                style={{ display: 'flex' }}
              />
            </div>

            <ul style={{ padding: '0rem 1.5rem', margin: '0', height: 'fit-content' }}>
              {
                menuList.map(({ id, label, dropDown, path }, index) => (
                  <li 
                    key={id} 
                    className={`position-relative dropdown-parent $`} 
                    onClick={() => setDropDownActive((prev) => (prev === id ? null : id))} // Toggle the active state
                  >
                    {/* First Level Button*/}
                    <Link 
                      to={path} 
                      className='d-flex align-items-center justify-content-between' 
                      onClick={(e) => {
                        if (dropDown.length) {
                          e.preventDefault(); // Prevent navigation if there's a dropdown
                        } else {
                          setMenuActive(false);
                        }
                      }}
                    >
                      {label}
                      <span>{dropDown.length && (dropdownActive === id ? "-" : "+")}</span>
                    </Link>

                    {/* Second Level Menu */}
                    {dropDown.length > 0 && (
                      <ul className={`dropdown ${dropdownActive === id ? "dropdown_active" : ""} ${index===menuList.length-1}`}
                        style={{ 
                          padding: (index!==menuList.length-1 && dropdownActive === id) ? 
                            '0rem 1rem 0.3rem 1.5rem' : 
                            '0rem 1rem 0rem 1.5rem' 
                        }}
                      >
                        {dropDown.map(({ id, path, label }) => (
                          <li key={id}>
                            <Link to={path} onClick={() => setMenuActive(false)}>
                              {label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}

                  </li>
                ))
              }
            </ul>

          </div>


        </div>
      </div>
    </div>
  )
}

export default MobileMenu;

